/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { Entity } from "@backstage/catalog-model";

export const ROUTE_DISPLAY_METADATA = "routes";

export const useProjectEntity = (entity: Entity) => {
  return {
    routes: entity.metadata?.[ROUTE_DISPLAY_METADATA] as string[],
  };
};
